import { render, staticRenderFns } from "./ContactDetailLabelBadge.vue?vue&type=template&id=137f1298"
import script from "./ContactDetailLabelBadge.vue?vue&type=script&lang=js"
export * from "./ContactDetailLabelBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports